var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"app-button",class:[
    `is-${_vm.size}`,
    // `is-${type}`, uncomment when we remove the deprecated types
    {
      'has-icon': _vm.icon,
      'prepend-icon': _vm.icon && _vm.prepend,
      'is-block': _vm.isBlock,
      'is-disabled': _vm.disabled,
      'no-branding': _vm.noBranding,
      // remove type checks when we remove the deprecated types
      'is-success': ['affirm', 'success'].includes(_vm.type),
      'is-danger': ['decline', 'danger'].includes(_vm.type),
      'is-primary': _vm.type === 'primary',
      'is-secondary': _vm.type === 'secondary',
    },
  ],attrs:{"aria-label":_vm.$slots.default ? _vm.$slots.default[0].text : _vm.text,"disabled":_vm.disabled,"type":_vm.nativeType,"href":_vm.href,"target":_vm.target},on:{"click":function($event){return _vm.$emit('click', $event);}}},[(!_vm.isIcon && (_vm.$slots.default || _vm.text))?_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.text || _vm.$slots.default[0].text))]):_vm._e(),(_vm.icon || _vm.isIcon)?[_c('AppIcon',{staticClass:"app-button-icon",attrs:{"icon":_vm.isLoading ? 'fa-solid fa-spinner fa-spin' : _vm.icon,"size":_vm.iconSize,"data-test":"app button icon"}}),(_vm.isIcon)?_c('span',{staticClass:"sr-only",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }